import { render } from "./ClubcardTokenStatus.vue?vue&type=template&id=476dc856"
import script from "./ClubcardTokenStatus.vue?vue&type=script&lang=js"
export * from "./ClubcardTokenStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__